import React from 'react';
import { Backdrop, Box, Typography } from '@mui/material';
import './LoadingOverlay.css';

const LoadingOverlay = ({ open, message = 'Loading...', variant = 'default' }) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        backdropFilter: 'blur(8px)',
      }}
      open={open}
    >
      <Box className="loading-container">
        <div className={`bouncing-dots ${variant}`}>
          <div className="dot dot-1"></div>
          <div className="dot dot-2"></div>
          <div className="dot dot-3"></div>
          <div className="dot dot-4"></div>
          <div className="dot dot-5"></div>
        </div>
        <Typography 
          variant="h6" 
          className="loading-text"
          sx={{ 
            mt: 4, 
            color: '#374151', 
            fontWeight: 500,
            fontSize: '16px',
            textAlign: 'center'
          }}
        >
          {message}
        </Typography>
      </Box>
    </Backdrop>
  );
};

export default LoadingOverlay;